import React from 'react';
import ListCRUD from 'mrf/view/ListCRUD';
import {trimCallbackTooltip} from "../../../mrf/utils/trim";
import role from 'role';
import {useTranslation} from "react-i18next";

export default function ParameterList({match}) {
    const {t} = useTranslation();

    const fields = [
        {name: 'Code', key: 'code'},
        {name: 'Name', key: 'name', map: t},
        {name: 'Value', key: 'value', map: trimCallbackTooltip(50)},
    ];

    return <ListCRUD
        singular='systemParameter'
        fields={fields}
        match={match}
        disableNewButton
        disableViewButton
        canNew={[role.ADMIN]}
        canEdit={role.ADMIN}
    />;
}
